<style lang="scss">
.navigation-overlay {
    visibility: hidden;
    position: fixed;
    width: 100vw;
    height: 100vh;
    z-index: 1;
    top: 0;
    left: 0;
    opacity: 0;
    transition: opacity 0.2s, visibility 0s 0.2s;
    background: theme("colors.red");
    &.active {
        visibility: visible;
        opacity: 1;
        transition: opacity 0.2s;
    }
}

/**
 * Disable body scrolling when overlayer is visible
 */

body.noscroll {
    overflow: hidden;
    width: 100vw;
    height: calc(100vh - 64px);
    height: calc(var(--vh, 1vh) * 100 - 64px); //vh fix from app.js
}
</style>

<template>
    <div class="navigation-overlay bg-dark" :class="{'active': $root.navigationIsVisible}">
        <slot></slot>
    </div>
</template>

<script>
export default {

}
</script>
